import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { autocompleteCity } from "@/graphql/queries";
import { create } from "zustand";
import type { State } from "@/types/common";
import type { AutocompleteCityQuery } from "@/API";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const autoCompleteCitiesState = create<State<AutocompleteCityQuery>>(
  () => ({
    data: null,
    isLoading: false,
    error: null,
    isFetching: false,
  }),
);

export const autoCompleteCitiesStateIsloading = () =>
  autoCompleteCitiesState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const autoCompleteCitiesStateIsError = (error: GraphQLError[]) =>
  autoCompleteCitiesState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const autoCompleteCitiesStateIsSuccess = (
  queryResult: AutocompleteCityQuery,
) =>
  autoCompleteCitiesState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
  }));

export const searchForAutoCompleteCities = async (search: string) => {
  autoCompleteCitiesStateIsloading();

  try {
    const response = await client.graphql({
      query: autocompleteCity,
      variables: {
        value: search,
      },
    });

    autoCompleteCitiesStateIsSuccess(response.data as AutocompleteCityQuery);
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<AutocompleteCityQuery>;
    autoCompleteCitiesStateIsError(graphQl.errors as GraphQLError[]);
  }
};
